<template>
  <div class="header">
    <div class="header-logo">
      <img :src="logo" alt="">
    </div>
    <div class="header-right">
      <div class="header-tab">
        <div :class="activeVal == index ? 'tablist on' : 'tablist'" v-for="(item, index) in tabList" :key="index" @click="getTab(index)">
          <div class="tablist-title">{{ item.title }}</div>
          <div class="tablist-line" v-if="activeVal == index"></div>
        </div>
      </div>
      <div class="header-search">
        <input type="text" placeholder="输入要搜索的内容" v-model="keyword" @keyup.enter="getSearch">
        <img :src="searchIcon" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { getCate } from "@/api/index";
export default {
  name: 'DrugHeader',
  data () {
    return {
      logo: "static/images/logo.png",
      searchIcon: "static/images/home/icon-search.png",
      tabList: [
        {
          title: "网站首页",
          path: "/",
        },
        {
          title: "企业简介",
          path: "/introduce",
        },
        {
          title: "产品中心",
          path: "/production",
          id: null
        },
        {
          title: "新闻资讯",
          path: "/news",
          id: null
        },
        {
          title: "企业公告",
          path: "/notice",
          id: null
        },
        {
          title: "企业文化",
          path: "/culture",
          id: null
        },
        {
          title: "咨询互动",
          path: "/consult",
        }
      ],
      keyword: ""
    }
  },
  computed: {
    activeVal: {
      get () {
        var val = this.$store.state.activeVal;
        var pid = this.tabList[val].id ? this.tabList[val].id : null;
        this.$store.commit("getpid", pid);
        return val;
      },
      set (value) {
        this.$store.commit("getactive", value);
      }
    },
    pid: {
      get () {
        return this.$store.state.pid;
      },
      set (value) {
        this.$store.commit("getpid", value);
      }
    }
  },
  methods: {
    getTab(index) {
      this.$store.commit("getactive", index);
      if(this.tabList[index].id) {
        this.$store.commit("getpid", this.tabList[index].id);
      } else {
        this.$store.commit("getpid", null);
      }
      this.$router.push({
        path: this.tabList[index].path
      })
    },
    // 搜索事件
    getSearch() {
      var paramId = this.$route.query.id;
      if(this.pid && !paramId) {
        this.$store.commit("getkey", this.keyword);
      } else {
        this.$message({
          message: '请在列表中搜索相关内容',
          type: 'warning'
        })
      }
    }
  },
  mounted() {
    getCate().then((res) => {
      if(res.data.code == 1) {
        var list = res.data.data;
        for(let i in list) {
          for(let j in this.tabList) {
            if(list[i].name == this.tabList[j].title) {
              this.tabList[j].id = list[i].id;
            }
          }
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  .header {
    width: 100%;
    height: 80px;
    overflow: hidden;
    background: rgba(0, 34, 68, 0.5);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-logo {
      margin-left: 50px;
      height: 56px;
      img {
        height: 100%;
      }
    }
    .header-right {
      margin-right: 31px;
      display: flex;
      .header-tab {
        margin-right: 40px;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 18px;
        .tablist {
          &.on {
            font-family: "PingFang SC-Medium";
          }
          margin-left: 30px;
          cursor: pointer;
          .tablist-line {
            height: 4px;
            background: linear-gradient(270deg, #B1FAFF 0%, #4392EC 100%);
          }
        }
      }
      .header-search {
        width: 301px;
        height: 39px;
        background: rgba(242, 242, 241, 0.33);
        display: flex;
        align-items: center;
        justify-content: space-between;
        input {
          width: 200px;
          height: 100%;
          color: #fff;
          border: 0;
          margin-left: 14px;
          background: none;
          font-size: 16px;
        }
        input::-webkit-input-placeholder {
          color: #fff;
        }
        input:focus {
          outline: none;
        }
        img {
          width: 20px;
          height: 20px;
          margin-right: 14px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DrugHeader.vue